<section class="sidebar">
  <div class="sidebar-nav">
    <div class="nav-item">
      <!-- Named for the label under it (WCAG 1.1.1, 2.5.3): the image is
           decoration, and its old alt made the button "Pathway". -->
      <button type="button" (click)="home()" mat-icon-button class="home" aria-label="Home">
        <img src="/assets/images/pathway/pathway-icon.svg" alt=""/>
      </button>
      <span class="nav-text">Home</span>
    </div>
    <div class="nav-item" [class.highlight]="highlight || isChatViaOpen">
      <button type="button" [class.shake-animation]="showWiggleAnimation()" (click)="toggleChat()" (mouseenter)="showTooltip()"
              mat-icon-button class="chat">
        <img src="/assets/images/chat-gpt/ask-via.svg" alt="Ask Via"/>
      </button>

      <span class="nav-text">Ask Via</span>
    </div>
    <div class="nav-item relative" [class.highlight]="isConnectSidebarOpen()">
      <button
        type="button"
        (click)="toggleConnect()"
        [class.disabled]="isConnectItemDisabled()"
        class="connect"
        aria-label="Connect"
      >
        <mat-icon svgIcon="connect-icon"></mat-icon>
      </button>

      <!-- How many schools are waiting to be sent to. Ticking one elsewhere on
           the page has to have a visible consequence, or the member has no way
           to know where the request went or that it has not gone yet. -->
      @if (connectPendingCount()) {
        <span
          class="connect-count"
          [attr.aria-label]="
            connectPendingCount() +
            (connectPendingCount() === 1
              ? ' school waiting to be sent to'
              : ' schools waiting to be sent to')
          "
        >
          {{ connectPendingCount() }}
        </span>
      }

      <span class="nav-text">Connect</span>
      <!--
        CONNECT.1 (gate D5c). Was a red warning triangle for "outdated", and
        nothing it flagged was ever wrong: it fired on any goal change. The
        flag now means the member's goal brought employers or service
        organizations they have not seen, which is good news, so it is green
        and says "New". The pending-schools count wins when both apply: that
        one is waiting on the member.
      -->
      @if (isConnectionOutdated() && !connectPendingCount()) {
        <span class="connect-new" aria-label="New organizations match your goal">New</span>
      }
    </div>
    <div class="nav-item" [class.highlight]="isJstSidebarOpen() || isAceSidebarOpen()">
      <button
        type="button"
        (click)="toggleJstUpload()"
        class="jst-upload"
        [class.parsing]="isJstParsing()"
        [attr.aria-busy]="isJstParsing() ? true : null"
        [attr.aria-label]="
          isJstParsing() ? 'Reading your transcript' : 'Upload a transcript'
        "
      >
        <fa-icon [icon]="['fas', 'upload']"></fa-icon>
      </button>
      <span class="nav-text">Upload</span>
    </div>

    <div class="nav-item info">
      <fa-icon
        [icon]="['fal', 'info-circle']"
        (click)="openChatInfoDialog()"
      ></fa-icon>
      <span class="nav-text">Info</span>
    </div>
  </div>
</section>

<ng-template #chatAccessTooltip>
  <div class="custom-tooltip large green intro-via">
    <mat-icon svgIcon="chat-via"></mat-icon>
    <h3>Unlock Via with an account</h3>
    <p>Get personalized career and education guidance by chatting with Via</p>
  </div>
</ng-template>

<ng-template #connectPromptTooltip>
  <div
    role="button"
    tabindex="0"
    (keydown.enter)="toggleConnect()"
    (keydown.space)="$event.preventDefault(); toggleConnect()"
    (click)="toggleConnect()" class="custom-tooltip large green connect-tooltip">
    <fa-icon [icon]="['fal','times']" (click)="closeTooltipConnect($event)"></fa-icon>
    <h3>You have {{ matchesCount() }} opportunity matches!</h3>
    <p>Put the power in your hands. Connect your profile with trusted partners.</p>
  </div>
</ng-template>

<ng-template #connectDisabledTooltip>
  <div class="custom-tooltip large warn connect-tooltip">
    <fa-icon [icon]="['fal','times']" (click)="closeTooltipConnect($event)"></fa-icon>
    <h3>Connect is disabled!</h3>
    <p>Please complete your skills survey and set a career goal to use this feature</p>
  </div>
</ng-template>

<ng-template #outdatedConnectPromptTooltip>
  <div
    role="button"
    tabindex="0"
    (keydown.enter)="toggleConnect()"
    (keydown.space)="$event.preventDefault(); toggleConnect()"
    (click)="toggleConnect()" class="custom-tooltip large red connect-tooltip">
    <fa-icon [icon]="['fal','times']" (click)="closeTooltipConnect($event)"></fa-icon>
    <h3>
      Your Connections are Outdated!
    </h3>
    <p>Changing your goal has caused some of your connections to go stale. Select new connections for your new goal!</p>
  </div>
</ng-template>

<!-- Shown while a transcript is being read. Same green tag treatment as the
     Connect prompt above, deliberately: a snackbar in the top-right corner was
     nowhere near the control it refers to, and read as a system notification
     rather than as part of the sidebar. Closeable, like the Connect prompt. -->
<ng-template #jstParsingTooltip>
  <div class="custom-tooltip large green connect-tooltip">
    <fa-icon [icon]="['fal','times']" (click)="closeParsingTooltip($event)"></fa-icon>
    <h3>Reading your transcript</h3>
    <p>
      This usually takes under a minute. Keep exploring, and we'll open your results
      as soon as they're ready.
    </p>
  </div>
</ng-template>
